import React, { useState } from 'react';
import { Alert, Button, Col, Form, Row } from 'react-bootstrap';
import {
  DEFAULT_COMPARABLE_SERVICES,
  servicePickerLabel
} from '../../config/rateShopConstants';
import HelpTip from '../HelpTip';
import BrandIcon from '../BrandIcon';
import { carrierIconFor } from '../../config/brandIcons';
import { allowedServiceGroups } from '../../lib/serviceCatalog';
const AllowedServices = ({ draft, update, disabled }) => {
  const [search, setSearch] = useState('');
  const groups = allowedServiceGroups(
    draft.comparableServices,
    draft.carrierAccounts
  );
  const eligible = new Set(
    groups.filter(g => g.supported).flatMap(g => g.services.map(s => s.code))
  );
  const count = draft.comparableServices.filter(code =>
    eligible.has(code)
  ).length;
  const change = (code, checked) =>
    update({
      comparableServices: checked
        ? [...new Set([...draft.comparableServices, code])]
        : draft.comparableServices.filter(s => s !== code)
    });
  return (
    <div className="mb-4">
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
        <h5 className="mb-0">
          Services allowed to win{' '}
          <HelpTip label="Services allowed to win">
            Rate Shop picks the cheapest price among ONLY the ticked services.
            Unticked services can never be chosen — that is how overnight and
            air services stay out even when they are quoted.
          </HelpTip>
        </h5>
        <Button
          type="button"
          size="sm"
          variant="outline-secondary"
          disabled={disabled}
          onClick={() =>
            update({ comparableServices: [...DEFAULT_COMPARABLE_SERVICES] })
          }
        >
          Use recommended defaults
        </Button>
      </div>
      <p className="small text-muted mt-2">
        Rate Shop picks the cheapest price among ONLY the ticked services.
        Unticked services can never be chosen — that is how overnight and air
        services stay out even when they are quoted.
      </p>
      <p className="fw-bold">
        {count} services can win.
      </p>
      <Form.Label htmlFor="rate-shop-services-search">
        Find a service{' '}
        <HelpTip label="Find a service">
          Search service names or carrier codes. Services from accounts you turn
          off are hidden; their saved ticks are kept.
        </HelpTip>
      </Form.Label>
      <Form.Control
        id="rate-shop-services-search"
        className="mb-3"
        placeholder="Search services…"
        value={search}
        onChange={e => setSearch(e.target.value)}
      />
      {!draft.comparableServices.length && (
        <Alert variant="warning">
          Tick at least one service so Rate Shop has something to choose.
        </Alert>
      )}
      <div
        className="border rounded p-3"
        style={{ maxHeight: 420, overflowY: 'auto' }}
      >
        {groups.map(({ code, label, services, supported }) => {
          const shown = services.filter(s =>
            `${servicePickerLabel(s.code)} ${
              s.code
            } ${label} ${s.carrierCodes.join(' ')}`
              .toLowerCase()
              .includes(search.toLowerCase())
          );
          return shown.length ? (
            <details
              key={code}
              open={search ? true : undefined}
              className="mb-3"
            >
              <summary className="fw-bold mb-2">
                <span className="d-inline-flex align-items-center gap-2">
                  <BrandIcon src={carrierIconFor(code)} alt={label} size={18} />
                  <span>{label}</span>
                </span>{' '}
                ·{' '}
                {
                  services.filter(s =>
                    draft.comparableServices.includes(s.code)
                  ).length
                }{' '}
                of {services.length} ticked
              </summary>
              <Row>
                {shown.map(service => (
                  <Col lg={6} key={service.code}>
                    <Form.Check
                      id={`rate-shop-service-${code}-${service.code}`}
                      disabled={disabled}
                      checked={draft.comparableServices.includes(service.code)}
                      onChange={e => change(service.code, e.target.checked)}
                      className="mb-2"
                      label={
                        <span className="small">
                          {servicePickerLabel(service.code)}
                          <small className="d-block text-muted">
                            {service.code}
                          </small>
                          <HelpTip label={service.name}>
                            {supported
                              ? 'Tick this service to let its price win when an enabled account quotes it.'
                              : 'These carriers are not used by Rate Shop. Saved ticks are kept, but these services cannot win.'}
                          </HelpTip>
                        </span>
                      }
                    />
                  </Col>
                ))}
              </Row>
            </details>
          ) : null;
        })}
      </div>
    </div>
  );
};
export default AllowedServices;
